import * as React from "react";
import { type RouteProps } from "react-router";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Balances = React.lazy(() => import("./Balances"));

export default function BalanceIndex(): Array<React.ReactElement<RouteProps>> {
    return [
        <PermissionRoute
            permissions={[ "see_balances" ]}
            title="Customer Balances | Shopfront"
            path="/customers/balances"
            key="customer-balances"
            element={<Balances />}
        />,
    ];
}
